import {
  instance as axios,
  axios as $axios,
  instance
} from "../services/axios";
import VueCookies from "vue-cookies";
import { createStore } from "vuex";
import router from "../router";
import { liff, config, liffMock } from "../main";
import { logger } from "@/services/log.js";
import { appConfig } from "../aLwAJXh7rUuwykLl";
let field = {
  id_card: "",
  prefix: "",
  first_name_th: "",
  first_name_en: "",
  last_name_th: "",
  last_name_en: "",
  email: "",
  telephone: "",
  gender: "",
  birthday: "",
  birthday_day: "",
  birthday_month: "",
  birthday_year: "",
  nickname: "",
  nickname_en: "",
  country: "",
  home_address: "",
  town: "",
  alley: "",
  road: "",
  subdistrict: "",
  district: "",
  province: "",
  zip_code: "",
  optional_telephone: "",
  id_card_image: "",
  facebook: "",
  x: "",
  is_company: "",
  company_type: "",
  company_branch_type: "",
  company_branch_no: "",
  company_branch: "",
  passport_no: ""
};
const store = createStore({
  state: {
    shortProfile: field,
    completeProfile: {},
    theme: {
      is_custom_privacy_link: "0",
      is_center_point: "0",
      consent_url_link: "",
      is_right_request_url: "0",
      right_request_url: "",
      is_term_and_con_url: "0",
      term_and_con_url: "",
      themeBackGround: "",
      themeBackgroundPage: "",
      themeDisableColor: "",
      themeLightPrimaryColor: "",
      line_display_code_countdown: "",
      line_display_right_request_link: "",
      line_display_logout_button: "",
      themeLogoHomePage: "",
      themeLogoLine: "",
      themeLogoLoginPage: "",
      themePrimaryColor: "",
      themePrintLogo: "",
      themeSecondaryColor: "",
      themeSolidColor: "",
      themeTransactionCodeBanner: "",
      themeTransactionCodeEarn: "",
      themeTransactionCodeError: ""
    },
    editPhonenumber: false,
    templateReady: false,
    count: 0,
    domain: "",
    province: [],
    languageList: [],
    profileFields: null,
    socialAnswer: [],
    authenticate: false,
    isUser: 0,
    userProvider: {
      userId: "",
      displayName: "",
      pictureUrl: ""
    },
    verification: {
      isHaveIdCard: false,
      isHavePassport: false,
      newUser: false,
      isActive: false,
      idCard: "",
      passport: ""
    },
    isMemberBypass: 0,
    cloneProfile: {},
    isEmailDuplicate: false
  },
  mutations: {
    setShortProfile: async function (state, val) {
      if (val) {
        state.shortProfile = val;
      }
    },
    setCloneProfile: async function (state, val) {
      if (val) {
        state.cloneProfile = val;
      }
    },
    setAuthen: async function (state, val) {
      state.authenticate = val;
    },
    setEmailDuplicate: async function (state, val) {
      state.isEmailDuplicate = val;
    },
    setTheme: async function (state, val) {
      state.theme = val.result;
      state.domain = val.themeLogoDomain;
    },
    setEditPhoneNumber: function (state, val) {
      state.editPhonenumber = val;
    },
    setTemplateIsReady: function (state, val) {
      state.templateReady = val;
    },
    setProvince: function (state, val) {
      state.province = val;
    },
    setCount: function (state, val) {
      state.count = val;
    },
    setLanguageList: function (state, val) {
      state.languageList = val;
    },
    setProfileFields: function (state, val) {
      state.profileFields = val;
    },
    setSocialUser: function (state, val) {
      state.socialAnswer = val;
    },
    setIsMemberBypass: function (state, val) {
      state.isMemberBypass = val;
    },
    setVerification: function (state, val) {
      state.verification = val;
    },
    setCardVerification: function (state, val) {
      let { id_card, passport, isActive } = val;
      state.verification.idCard = id_card;
      state.verification.isActive = isActive;
      state.verification.passport = passport;
    },
    setIsUser: function (state, val) {
      state.isUser = val.status;
      state.userProvider = val.provider;
    }
  },
  actions: {
    getUserProfile: async ({ commit, dispatch, state }, flag) => {
      commit("setCount", state.count + 1);

      if (state.templateReady && state.shortProfile.user_guid && !flag) {
        return state.shortProfile;
      }
      if (state.count == 2 && state.shortProfile.user_guid && !flag)
        return state.shortProfile;
      return await axios(`/api/v1/user/GetUserProfile`)
        .then(async res => {
          if (res.result == 1) {
            if (!res.detail.user_guid) {
              let body = {
                SocialProvider: config.socialProvider,
                SocialId: VueCookies.get("user_profile_token").userId
              };
              axios.post(`/api/v1/user/unpair`, body).then(async data => {
                if (data.result == 1) {
                  VueCookies.remove("token");
                  VueCookies.remove("otp_session");

                  VueCookies.remove("hourglass_register_success");
                  router.replace({
                    path: "/validatetelephone"
                  });
                } else {
                  VueCookies.remove("token");
                  router.replace({
                    path: "/validatetelephone"
                  });
                }
              });
              return false;
            }
            let bd = res.detail.birthday;
            if (new Date(bd).getYear() == -147) {
              res.detail.birthday = "";
              res.detail.birthday_day = "";
              res.detail.birthday_month = "";
              res.detail.birthday_year = "";
            }
            res.detail.nationality_id =
              res.detail.nationality_id == 0 ? null : res.detail.nationality_id;

            commit("setShortProfile", JSON.parse(JSON.stringify(res.detail)));
            commit("setCloneProfile", JSON.parse(JSON.stringify(res.detail)));

            return res;
          } else {
            commit("setShortProfile", field);
          }
        })
        .catch(async err => {
          if (err.status == 401) {
            const res = await dispatch("checkHasUser");
            if (res.result == 0) return router.push("validatetelephone");
            return false;
          }

          return false;
        });
    },
    checkHasUser: async ({ commit, dispatch }) => {
      try {
        return new Promise(async (resolve, reject) => {
          const response = await dispatch("getUserBind");
          resolve(response);
        }).catch(err => {
          reject(err);
        });
      } catch (error) {
        return reject(error);
      }
    },
    setCompleteProfile: async ({ commit, rootGetters, state }, payload) => {
      state.completeProfile = payload.detail;
    },
    refreshUserProfile: async ({ commit, rootGetters }) => {
      try {
        if (!VueCookies.isKey("token")) return;
        await axios({
          url: `/api/v1/user/GetUserProfile`,
          headers: rootGetters["api/headers"],
          method: "get"
        })
          .then(res => {
            if (res.result == 1) {
              commit("setShortProfile", res.detail);
              commit("setCloneProfile", JSON.parse(JSON.stringify(res.detail)));
            } else {
              commit("setShortProfile", field);
            }
          })
          .catch(error => {
            const code = parseInt(error.response && error.response.status);
            if (code === 401) {
              console.log(code);
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    login: async ({ state, commit }) => {
      try {
        var profile = null;

        if (!config.socialID)
          profile = await VueCookies.get("user_profile_token");
        if (profile)
          VueCookies.set("user_profile_token", profile, 60 * 60 * 24 * 30);
        let body = {
          SocialProvider: config.socialProvider,
          SocialId: profile?.userId || config.socialID
        };

        const response = await axios.post(`/api/v1/user/LoginExternal`, body);

        if (response.result == 1) {
          if (response.detail.token) {
            VueCookies.set("token", response.detail.token, "1y");

            commit("setAuthen", true);
          } else {
            commit("setAuthen", false);
            return { result: 0 };
          }
        } else {
          VueCookies.remove("hourglass_register_success");
          VueCookies.remove("token");
          commit("setAuthen", false);
        }

        return response;
        // });
      } catch (error) {
        logger({
          response: error.response || {
            config: { url: "/api/v1/user/LoginExternal", method: "post" }
          },
          action: { id: 3, action: "login external" }
        });
        return error;
      }
    },

    getProfileFromLine: async ({ commit }) => {
      const profile = await liffMock.getProfile();
      VueCookies.set("user_profile_token", profile, 60 * 60 * 24 * 30);
      commit("setIsUser", { status: 0, provider: profile });
      return profile;
    },
    getLanguage: async ({ commit }) => {
      const resp = await instance("/api/v1/setting/display_language");
      let data = resp.detail.sort((a, b) => a.sort_order - b.sort_order);
      commit("setLanguageList", data);
      return data;
    },
    getTheme: async ({ commit }) => {
      const resp = await this.axios("/api/v1/Setting/theme");
      commit("setTheme", resp.detail);
      return resp;
    },
    getProfileFields: async ({ state, commit }, type) => {
      const resp = await instance(
        `/api/v1/user/registerform/${type == 0 ? 1 : type}`
      );
      // commit("setTheme", resp.detail);
      commit("setProfileFields", resp);
      return resp;
    },
    setReady: async ({ commit, state }) => {
      if (!state.templateReady) commit("setTemplateIsReady", true);
      // return resp;
    },
    getProvince: async ({ commit, state }, flag = true) => {
      if (state.province.length > 0 && flag) {
        return state.province;
      }
      const resp = await $axios(
        `${appConfig.VUE_APP_ADDRESS_API}/address/form/province`,
        {
          headers: {
            "LANGUAGE-ID": VueCookies.isKey("lang")
              ? VueCookies.get("lang")?.lang || 1
              : 1
          }
        }
      );
      let temp = resp.map(el => {
        return { ...el, display_name: el.display_name || el.name };
      });
      commit("setProvince", temp);
      return temp;
    },
    getUserBind: async ({ commit, state }) => {
      var profile = null;
      const isLogin =
        VueCookies.get("user_profile_token") == "undefined" ||
        !VueCookies.get("user_profile_token") ||
        !VueCookies.isKey("user_profile_token");

      if (config.isLoginLine) {
        if (!VueCookies.isKey("user_profile_token")) {
          try {
            profile = await liff.getProfile();
          } catch (error) {
            logger({
              response: {
                data: [],
                config: { method: "onErrorGetLineProfile" },
                status: 401
              },
              action: {
                id: 3,

                note: JSON.stringify({
                  responseLine: error.message,
                  cookie: VueCookies.get("user_profile_token") || "null",
                  isLogin: isLogin,
                  isLoginLine: config.isLoginLine
                })
              }
            });
          }
        } else {
          profile = await VueCookies.get("user_profile_token");
        }
        config.socialID = profile?.userId;
      }
      if (profile)
        VueCookies.set("user_profile_token", profile, 60 * 60 * 24 * 30);
      let body = {
        SocialProvider: config.socialProvider,
        SocialId: profile?.userId || config.socialID
      };
      function getRawParam(key) {
        const match = window.location.search.match(
          new RegExp(`[?&]${key}=([^&]*)`)
        );
        return match
          ? decodeURIComponent(match[1].replace(/\+/g, "%2B"))
          : null;
      }

      const member = getRawParam("member");
      if (member || window.sessionStorage.getItem("token_bypass")) {
        commit("setIsMemberBypass", 1);
        return 1;
      }
      const resp = await axios.post(`/api/v1/user/CheckSocialBind`, body);
      if (resp.result == 0) {
        VueCookies.remove("token");
        VueCookies.remove("hourglass_register_success");
        VueCookies.remove("popupModalRegister");
        VueCookies.remove("telephone_login");
      }
      commit("setIsUser", { status: resp.result, provider: profile });
      if (resp.result == 0) await VueCookies.remove("token");

      return resp.result;
    },
    getConsentList: async (_, userConsentResponseList = []) => {
      const res = await axios("/api/v1/setting/additional_consent/listactive");
      return res.detail.map(item => {
        const parts = item.description.split(/(\{\{.*?\}\})/g).filter(Boolean);
        const value = userConsentResponseList.find(
          el => el.additional_consent_id == item.id
        );
        return {
          ...item,
          is_consent: value ? value.is_consent : 0,
          parsedDescription: parts
        };
      });
    },
    getUserSocial: async ({ commit, state }) => {
      const resp = await instance("/api/v1/user/GetUserSocialMediaList");
      commit("setSocialUser", resp.detail);
      let profile = { ...state.shortProfile, social: resp.detail };

      commit("setShortProfile", profile);
      return resp.detail;
    },
    getVerification: async ({ commit, state }, data) => {
      commit("setVerification", data);
    },

    async unpairUser({ commit, dispatch }) {
      try {
        // filter.SocialId = config.socialID;
        let filter = {
          SocialProvider: config.socialProvider,
          SocialId:
            config.socialID ||
            VueCookies?.get("user_profile_token")?.userId ||
            VueCookies?.get("telephone_login")
        };
        const data = await instance.post(`/api/v1/user/unpair`, filter);

        if (data.result == 1) {
          VueCookies.remove("token");
          VueCookies.remove("hourglass_register_success");
          VueCookies.remove("popupModalRegister");
          VueCookies.remove("telephone_login");
          VueCookies.remove("otp_session");
          return { success: true, result: 1 };
        } else {
          return {
            success: false,
            result: 0,
            message: data.message
          };
        }
      } catch (error) {
        VueCookies.remove("token");
        VueCookies.remove("hourglass_register_success");
        VueCookies.remove("popupModalRegister");
        VueCookies.remove("telephone_login");
        return { success: false, result: 0, message: "An error occurred." };
      }
    }
  },
  getters: {
    getProfile: state => {
      return state.shortProfile;
    },
    isEmailDuplicate: state => {
      return state.isEmailDuplicate;
    }
  }
});
export default store;
